import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import CircularProgress from '@mui/material/CircularProgress';

import {
  CreateContainer,
  TopRow,
  BackGroup,
  BackIconButton,
  BackText,
  StepRow,
  StepTab,
  StepBadge,
  StepLabel,
  Card,
  CardTitle,
  FooterRow,
  CancelButton,
  NextButton as GenerateButton,
} from './ElectronicContractCreateStyled';
import { PreviewBody, PrevButton, A4Page } from './ElectronicContractPreviewStyled';
import ElectronicContractPreviewPage from './ElectronicContractPreviewPage';

const ElectronicContractPreview = ({ form, isEditing, clauseContentMap, logoSeal, branchName, isSaving, onBack, onPrev, onGenerate }) => {
  const { t } = useTranslation();

  const selectedLogo = logoSeal?.logos?.find(l => l.id === form?.logoId) || logoSeal?.logos?.[0];
  const selectedSeal = logoSeal?.seals?.find(s => s.id === form?.sealId) || logoSeal?.seals?.[0];
  const primaryLogoUrl = selectedLogo?.imageUrl || null;
  const primarySealUrl = selectedSeal?.imageUrl || null;

  const pageProps = {
    name: form?.name,
    category: form?.category,
    branchName,
    clauses: form?.clauses || [],
    contentMap: clauseContentMap || {},
    logoUrl: form?.showLogo ? primaryLogoUrl : null,
    sealUrl: form?.showSeal ? primarySealUrl : null,
  };

  return (
    <CreateContainer>
      {/* 스텝 + 목록으로 */}
      <TopRow>
        <StepRow>
          <StepTab first>
            <StepBadge>
              <CheckIcon sx={{ fontSize: 18 }} />
            </StepBadge>
            <StepLabel>{t('계약서 정보')}</StepLabel>
          </StepTab>
          <StepTab active>
            <StepBadge active>2</StepBadge>
            <StepLabel active>{t('미리보기')}</StepLabel>
          </StepTab>
        </StepRow>

        <BackGroup onClick={onBack}>
          <BackIconButton aria-label="back">
            <ArrowBackIcon />
          </BackIconButton>
          <BackText>{t('목록으로')}</BackText>
        </BackGroup>
      </TopRow>

      {/* 미리보기 — 스크롤 가능한 연속 문서 */}
      <Card>
        <CardTitle>{t('계약서 미리보기')}</CardTitle>
        <PreviewBody>
          <A4Page>
            <ElectronicContractPreviewPage {...pageProps} />
          </A4Page>
        </PreviewBody>
      </Card>

      {/* 푸터 */}
      <FooterRow>
        <CancelButton onClick={onBack}>{t('취소')}</CancelButton>
        <PrevButton onClick={onPrev}>{t('이전')}</PrevButton>
        <GenerateButton onClick={onGenerate} disabled={isSaving}>
          {isSaving && <CircularProgress size={18} sx={{ color: '#fff', marginRight: '8px' }} />}
          {isEditing ? t('수정') : t('생성')}
        </GenerateButton>
      </FooterRow>
    </CreateContainer>
  );
};

export default ElectronicContractPreview;
